import { render, staticRenderFns } from "./PhysicalLocationForm.vue?vue&type=template&id=dd14649c&scoped=true&"
import script from "./PhysicalLocationForm.vue?vue&type=script&lang=js&"
export * from "./PhysicalLocationForm.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalLocationForm.vue?vue&type=style&index=0&id=dd14649c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd14649c",
  null
  
)

export default component.exports